var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 34,
    viewBox: "0 0 62 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 34,
    rx: 14,
    fill: "#FFD23B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 54,
    height: 26,
    rx: 11,
    fill: "#27292F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7147 10.8781C30.8045 10.6017 31.1955 10.6017 31.2853 10.8781L32.5042 14.6296C32.5444 14.7532 32.6596 14.8369 32.7896 14.8369H36.7341C37.0247 14.8369 37.1455 15.2088 36.9104 15.3796L33.7192 17.6981C33.6141 17.7745 33.5701 17.9099 33.6103 18.0335L34.8292 21.785C34.919 22.0614 34.6026 22.2912 34.3675 22.1204L31.1763 19.8019C31.0712 19.7255 30.9288 19.7255 30.8237 19.8019L27.6325 22.1204C27.3974 22.2912 27.081 22.0614 27.1708 21.785L28.3897 18.0335C28.4299 17.9099 28.3859 17.7745 28.2808 17.6981L25.0896 15.3796C24.8545 15.2088 24.9753 14.8369 25.2659 14.8369H29.2104C29.3404 14.8369 29.4556 14.7532 29.4958 14.6296L30.7147 10.8781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteMobile);
export default __webpack_public_path__ + "static/media/favorite_mobile.3ab001f3c15b09761e1213cef86b7637.svg";
export { ForwardRef as ReactComponent };